import { render, staticRenderFns } from "./change-category-form.vue?vue&type=template&id=30228c70&"
import script from "./change-category-form.vue?vue&type=script&lang=ts&"
export * from "./change-category-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports